import { BasePhaseModel } from './BasePhaseModel';
import { IPhase, PhaseType } from '../types';

export interface ProposalPhaseData {
  summary?: string;
  accepted?: boolean;
  attachments?: string[];
  orderId?: string;
}

export class ProposalPhaseModel extends BasePhaseModel<ProposalPhaseData> {
  constructor(phase: IPhase<ProposalPhaseData>) {
    super(phase.type === PhaseType.PROPOSAL ? phase : { ...phase, type: PhaseType.PROPOSAL });
  }

  updateData(data: Partial<ProposalPhaseData>): IPhase<ProposalPhaseData> {
    return super.updateData({ ...(this.phase.data || {}), ...data });
  }

  markAccepted(): IPhase<ProposalPhaseData> {
    return this.updateData({ accepted: true });
  }
}
